import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_PERSONAL_DATA_REQUEST,
  FETCH_USER_PERSONAL_DATA_SUCCESS,
  FETCH_USER_PERSONAL_DATA_ERROR,
  FETCH_UPDATE_USER_SUCCESS,
  FETCH_UPDATE_USER_ERROR,
  FETCH_USER_VIGENTE_REQUEST,
  FETCH_USER_VIGENTE_SUCCESS,
  FETCH_USER_VIGENTE_ERROR,
  USER_HAS_CVL,
  USER_HAS_SOLICITUD_CREDITO
} from '../constants/user'
import {
  FETCH_USER_FILES_REQUEST,
  FETCH_USER_FILES_SUCCESS,
  FETCH_USER_FILES_ERROR
} from '../constants/document'
import {
  activeStep,
  deactivateStep
} from '../actions/utils'
import {
  nextStepSimulation
} from './credit'
import {
  reqGetUser,
  reqUpdateUser,
  reqGetUserPersonalData,
  reqGetUserFilesToSign,
  reqGetUserVigente,
  reqUserHasSolicitudCredito
} from '../../utils/httpRequests/user'
import {
  userObjFlatString
} from '../../utils/misc'
import {
  nzUserFilesToSign
} from '../../utils/httpRequests/misc'
import {
  gtagOKEvent,
  gtagErrorEvent
} from '../../utils/gtag'
import * as logger from '../../utils/logger'

export function getUser(token) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_USER_REQUEST
    })
    reqGetUser(token)
      .then(response => {
        const { auth } = getState()
        if (process.env.NODE_ENV === 'production' && auth.type === 'User') {
          const splittedRut = response.data.user.rut.split('-')
          const rut = `${splittedRut[0]}${splittedRut[1]}`
          window.adfx.pvAddUD('rut', rut)
        }
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: response.data.user
        })
      })
      .catch(error => {
        // console.log(error)
        // logger.error(error)
      })
  }
}
export function getUserPersonalInformation(token, userRut = null) {
  return (dispatch) => {
    dispatch({
      type: FETCH_USER_PERSONAL_DATA_REQUEST
    })
    dispatch(deactivateStep())
    reqGetUserPersonalData(token, userRut)
      .then(response => {
        dispatch({
          type: FETCH_USER_PERSONAL_DATA_SUCCESS,
          payload: response.data.user
        })
        dispatch(activeStep())
      })
      .catch(error => {
        dispatch(deactivateStep())
        logger.error(error)
        dispatch({
          type: FETCH_USER_PERSONAL_DATA_ERROR,
          payload: 'En estos momentos no es posible obtener tus datos. Por favor, vuelve a intentar más tarde.'
        })
      })
  }
}

export function getUserFilesToSign(token) {
  return (dispatch) => {
    dispatch({
      type: FETCH_USER_FILES_REQUEST
    })
    reqGetUserFilesToSign(token)
      .then(response => {
        dispatch({
          type: FETCH_USER_FILES_SUCCESS,
          payload: nzUserFilesToSign(response.data.result)
        })
      })
      .catch(err => {
        // console.log(err)
        dispatch({
          type: FETCH_USER_FILES_ERROR
        })
      })
  }
}

export function updateUser(userInfo, token) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_USER_PERSONAL_DATA_REQUEST
    })
    dispatch(deactivateStep())
    const { user, utils } = getState()
    reqUpdateUser(userInfo, token)
      .then(() => {
        dispatch({
          type: FETCH_UPDATE_USER_SUCCESS
        })
        dispatch(activeStep())
        dispatch(nextStepSimulation())
        const gtagObjString = userObjFlatString(userInfo, user, utils.regions, utils.communes, utils.banks)
        if (gtagObjString.length > 0) {
          gtagOKEvent('Datos Personales', 'Actualizacion', gtagObjString)
        }
      })
      .catch((err) => {
        dispatch(activeStep())
        window.scrollTo(0, 0)
        const error = err.response ? err.response.data.message : ''
        dispatch({
          type: FETCH_UPDATE_USER_ERROR,
          payload: error === '' || Array.isArray(error)
            ? 'En estos momentos no es posible actualizar tus datos. Por favor, vuelve a intentar más tarde.'
            : err.response.data.message
        })
        gtagErrorEvent('Datos Personales', 'Error', 'No se pudo actualizar la informacion del usuario')
      })
  }
}

export function userHasCVL() {
  return {
    type: USER_HAS_CVL
  }
}

export function userHasSolicitudCredito(token) {
  return dispatch => {
    reqUserHasSolicitudCredito(token)
      .then(response => {
        dispatch({
          type: USER_HAS_SOLICITUD_CREDITO,
          payload: response.data.hasSolicitudCredito
        })
      })
      .catch(err => {

        dispatch({
          type: USER_HAS_SOLICITUD_CREDITO,
          payload: false
        })
      })
  }
}

export function getUserVigente(token, rut) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_USER_VIGENTE_REQUEST
    })
    reqGetUserVigente(token, rut)
      .then(response => {
        // console.log('Response getUserVigente', response);
        dispatch({
          type: FETCH_USER_VIGENTE_SUCCESS,
          payload: response.data.result
        })
      })
      .catch(error => {
        // console.log(error);
        dispatch({
          type: FETCH_USER_VIGENTE_ERROR,
          payload: []
        })
      })
  }
}

export function getUserPersonalInformationDj(token, userRut = null) {
  return (dispatch) => {
    dispatch({
      type: FETCH_USER_PERSONAL_DATA_REQUEST
    })
    reqGetUserPersonalData(token, userRut)
      .then(response => {
        dispatch({
          type: FETCH_USER_PERSONAL_DATA_SUCCESS,
          payload: response.data.user
        })
      })
      .catch(error => {
        dispatch(deactivateStep())
        logger.error(error)
        dispatch({
          type: FETCH_USER_PERSONAL_DATA_ERROR,
          payload: 'En estos momentos no es posible obtener tus datos. Por favor, vuelve a intentar más tarde.'
        })
      })
  }
}